<template>
  <div>
    <!-- 翻译的配送单 -->
    <baseBreadcrumb
      :page="$t('message.porderTranslate')"
      :menu="$t('message.porder')"
    />

    <porderBaseTable :status="20" />
  </div>
</template>
<script>
import porderBaseTable from "@/components/porder/porderBaseTable/index";
export default {
  components: { porderBaseTable },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>